// Time of Concentration using LAG method
export function timeOfConcLagCalc(watershedLen, runoffCN, watershedSlope) {
  const hlf = Math.pow(watershedLen, 0.8);
  const s = 1000.0 / runoffCN - 9;
  const sf = Math.pow(s, 0.7);
  const slpf = 1140 * Math.pow(watershedSlope, 0.5);
  const timeC = (hlf * sf) / slpf;
  const roundedTimeC = Math.round(timeC * 100) / 100;

  return roundedTimeC;
}
